import { BaseModel } from "../base.model";

export class WorkflowStep extends BaseModel {
  name: string;
}
